import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './ServiceHistoryPanel.module.scss';
import 'src/css/themes.scss';
import { IconDropDown, IconDropDownReverse } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { strings } from 'src/localization';
import { random } from 'lodash';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
    index: number;
}

const ServiceHistoryPanel = (props: IProps) => {
    const [roOpen, setRoOpen] = useState(true);
    const toggleRo = useCallback(() => {
        setRoOpen(!roOpen);
    }, [roOpen]);

    let dealerCode: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].dealerCode) {
        dealerCode =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.DealerCode}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.svcHist[props.index].dealerCode}
                </div>
            </span>;
    }

    let locId: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].locId) {
        locId =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.LocationId}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.svcHist[props.index].locId}
                </div>
            </span>;
    }

    let openDate: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].openDate) {
        openDate =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.OpenDate}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.svcHist[props.index].openDate}
                </div>
            </span>;
    }

    let complDate: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].complDate) {
        complDate =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.CompletedDate}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.svcHist[props.index].complDate}
                </div>
            </span>;
    }

    let invDate: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].invDate) {
        invDate =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.InvoicedDate}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.svcHist[props.index].invDate}
                </div>
            </span>;
    }

    let odometer: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].openMile || props.connectedVehicle.svcHist[props.index].closeMile) {
        let odometerValue: string | null = null;
        let odometerLit: string | null = null;
        if (props.connectedVehicle.svcHist[props.index].openMile) {
            odometerLit = strings.OodmeterIn;
            odometerValue = props.connectedVehicle.svcHist[props.index].openMile;
        }
        if (props.connectedVehicle.svcHist[props.index].closeMile) {
            odometerValue = props.connectedVehicle.svcHist[props.index].closeMile;
            odometerLit = strings.OdometerOut;
        }
        if (props.connectedVehicle.svcHist[props.index].openMile && props.connectedVehicle.svcHist[props.index].closeMile) {
            odometerValue = props.connectedVehicle.svcHist[props.index].openMile + ' / ' +
            props.connectedVehicle.svcHist[props.index].closeMile;
            odometerLit = strings.OodmeterIn + ' / ' + strings.OdometerOut;
        }
        odometer =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {odometerLit}
                </div>
                <div className={css.infoData}>
                    {odometerValue}
                </div>
            </span>;
    }

    let serviceStatus: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].status) {
        serviceStatus =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.ServiceStatus}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.svcHist[props.index].status}
                </div>
            </span>;
    }

    let serviceTypeNumber: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].svcTypeNum) {
        serviceTypeNumber =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.ServiceTypeNumber}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.svcHist[props.index].svcTypeNum}
                </div>
            </span>;
    }

    let jobFields: ReactElement[] | null = null;
    if (props.connectedVehicle.svcHist[props.index].job.length > 0) {
        jobFields = props.connectedVehicle.svcHist[props.index].job.map(job => <div
            className={css.dataBlock} id={job.jobNum} key={random(99999)}>
            <div className={css.dataRow}>
                <div className={css.jobField1}>{job.jobNum}</div>
                <div className={css.jobField2}>{job.opId}</div>
                <div className={css.jobField3}>{job.opDesc}</div>
                <div className={css.jobField4}>{job.opInterval}</div>
            </div>
            <hr className={css.dataLine}></hr>
        </div>);
    }

    let jobData: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].job.length > 0) {
        jobData =
            <div>
                <div className={css.litRow}>
                    <p className={css.jobField1}>{strings.JobNumber}</p>
                    <p className={css.jobField2}>{strings.OperationId}</p>
                    <p className={css.jobField3}>{strings.Description}</p>
                    <p className={css.jobField4}>{strings.ServiceInterval}</p>
                </div>
                {jobFields}
            </div>;
    }

    let laborFields: ReactElement[] | null = null;
    if (props.connectedVehicle.svcHist[props.index].labor.length > 0) {
        laborFields = props.connectedVehicle.svcHist[props.index].labor.map(labor => <div
            className={css.dataBlock} id={labor.laborId} key={random(99999)}>
            <div className={css.dataRow}>
                <div className={css.field1}>{labor.laborId}</div>
                <div className={css.field2}>{labor.laborHrs}</div>
                <div className={css.field3}>{labor.laborDesc}</div>
            </div>
            <hr className={css.dataLine}></hr>
        </div>);
    }

    let laborData: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].labor.length > 0) {
        laborData =
            <div>
                <div className={css.litRow}>
                    <p className={css.field1}>{strings.LaborId}</p>
                    <p className={css.field2}>{strings.LaborHours}</p>
                    <p className={css.field3}>{strings.LaborDescription}</p>
                </div>
                {laborFields}
            </div>;
    }

    let partFields: ReactElement[] | null = null;
    if (props.connectedVehicle.svcHist[props.index].part.length > 0) {
        partFields = props.connectedVehicle.svcHist[props.index].part.map(part => <div
            className={css.dataBlock} id={part.partNum} key={random(99999)}>
            <div className={css.dataRow}>
                <div className={css.field1}>{part.partNum}</div>
                <div className={css.field2}>{part.partQty}</div>
                <div className={css.field3}>{part.partDesc}</div>
            </div>
            <hr className={css.dataLine}></hr>
        </div>);
    }

    let partData: ReactElement | null = null;
    if (props.connectedVehicle.svcHist[props.index].part.length > 0) {
        partData =
            <div>
                <div className={css.litRow}>
                    <p className={css.field1}>{strings.PartNumber}</p>
                    <p className={css.field2}>{strings.PartQty}</p>
                    <p className={css.field3}>{strings.PartDescription}</p>
                </div>
                {partFields}
            </div>;
    }

    let roData: ReactElement | null = null;
    let roIcon: ReactElement | null = null;
    if (roOpen && (dealerCode || locId || openDate || complDate || invDate || odometer || jobData || laborData || partData)) {
        roIcon = <IconDropDownReverse className={css.roIcon} onClick={() => toggleRo()} />;
        roData =
            <div>
                <div className={css.infoRow}>
                    {dealerCode}
                    {locId}
                    {openDate}
                    {complDate}
                    {invDate}
                    {odometer}
                    {serviceStatus}
                    {serviceTypeNumber}
                </div>
                {jobData}
                {laborData}
                {partData}
            </div>;
    } else {
        roIcon = <IconDropDown className={css.roIcon} onClick={() => toggleRo()} />;
    }

    return (
        <div className={css.panel}>
            <div id='headerBlock' className={css.headerBlock} onClick={() => toggleRo()}>
                <div className={css.header}>
                    <p className={css.headerLit}>
                        {strings.RONum}
                    </p>
                    <p className={css.headerValue}>
                        {props.connectedVehicle.svcHist[props.index].RO}
                    </p>
                </div>
                {roIcon}
            </div>
            <hr className={css.line}></hr>
            {roData}
        </div>
    );
};

export default ServiceHistoryPanel;